import React from 'react';
import '../css/FeaturesPage.css'; // Optional: Add a CSS file for styling

const FeaturesPage = () => {
  return (
    <div className="features-container">
      <header className="features-header">
        <h1>URL Shortener App Features</h1>
      </header>
      <div className="features-content">
        <h2>Core Features</h2>
        <ul>
          <li><strong>Shorten URLs:</strong> Instantly convert long URLs into short, user-friendly links.</li>
          <li><strong>Customizable Links:</strong> Create personalized URLs for better branding and recall.</li>
          <li><strong>Analytics Dashboard:</strong> Track clicks, user locations, and device types in real-time.</li>
        </ul>

        <h2>Advanced Functionalities</h2>
        <ul>
          <li><strong>Link Expiration:</strong> Set expiration dates for temporary links.</li>
          <li><strong>Password Protection:</strong> Secure links with passwords for private sharing.</li>
          <li><strong>API Access:</strong> Seamlessly integrate URL shortening into your applications via our API.</li>
        </ul>

        <h2>Additional Benefits</h2>
        <ul>
          <li><strong>QR Code Generation:</strong> Instantly generate QR codes for your shortened links.</li>
          <li><strong>Custom Domains:</strong> Use your own domain name for shortened URLs.</li>
          <li><strong>Bulk URL Shortening:</strong> Upload and process multiple URLs at once.</li>
        </ul>

        <h2>Security Features</h2>
        <ul>
          <li><strong>Spam Detection:</strong> Automatically detect and block malicious links.</li>
          <li><strong>HTTPS Support:</strong> Ensure secure redirection for all shortened URLs.</li>
        </ul>

        <h2>Why Choose Us?</h2>
        <ul>
          <li>Simple and intuitive user interface.</li>
          <li>Fast and reliable performance.</li>
          <li>Affordable pricing for premium features.</li>
        </ul>
      </div>
    </div>
  );
};

export default FeaturesPage;
